/**
 * ============================================================================
 *  SITE CONFIGURATION
 * ----------------------------------------------------------------------------
 *  Edit the values below to rebrand this template. These are the main knobs
 *  used across the app (header, footer, SEO, contact, payment page, etc.).
 * ============================================================================
 */

export const siteConfig = {
  brand: {
    name: 'Flash USDT Generator Pro',
    tagline: 'Flash USDT Generator Pro — Professional Multi-Chain USDT Flashing',
    description:
      'Flash USDT Generator Pro is the professional-grade flash USDT software for TRC-20, ERC-20 and BEP-20. Generate realistic USDT balances up to $10,000,000 daily with secure, tradable and swappable flash tokens.',
  },

  domain: 'https://flashusdtgeneratorpro.com',

  contact: {
    orderEmail: 'usdtflaher@gmail.com',
    supportEmail: 'usdtflaher@gmail.com',
    whatsapp: '18144751028',
    phoneDisplay: '+1 (814) 475-1028',
  },

  social: {
    twitter: 'https://twitter.com/yourbrand',
    facebook: 'https://facebook.com/yourbrand',
    instagram: 'https://instagram.com/yourbrand',
    telegram: 'https://t.me/yourbrand',
  },

  payment: {
    wallets: {
      bitcoin: 'bc1qwjp3pmgujc2vj5u07h3hpejzuumxad5kajspy5',
      usdt: 'TWuKSjUwLTPgF8fwt7tNqbRQZj3hSBjFA7',
    },
  },
};

export default siteConfig;
